import {
  APP_ZONES,
  PermissionConfig,
  ProfilePagesTags,
  WorkflowConfig,
} from '@finxone-platform/shared/sys-config-types';
import { defaultPageConfigurations } from '../../defaults/widgets/workflow-ui-constants.v2.type';
import { notificationKycApplicationSuccessWidgets } from '../../defaults/zones/profile/widget-sections/notification/notification-kyc-application';
import { PageConfig } from '../../zones/mobile/default-zone-page-setups';

// This migration is responsible for add a new page "Notification (Application Success)" after the 'Notification (Beneficiary Removed)'  under profile zone-notification center
//Story 7710

type UpdatedPageConfig = PageConfig;

const notificationKycApplicationSuccessPage = () => {
  return {
    name: 'notification-application-success',
    title: 'Notification (Application Success)',
    widgets: notificationKycApplicationSuccessWidgets,
    tags: [ProfilePagesTags.NOTIFICATIONS_CENTER],
    pageConfiguration: {
      ...defaultPageConfigurations,
      url: 'notification-application-success',
      isRemovable: false,
      mainComponentPageName: 'ParentContainerComponent',
      isUsingHtmlStructure: true,
    },
  } as UpdatedPageConfig;
};

export const getV1_0_169ToV1_0_170 = (workflowConfig: WorkflowConfig) => {
  const oneToOneKeys = Object.keys(workflowConfig);
  const mappingObject = {};
  // Assign mappings to not modify this version upgrade
  oneToOneKeys.forEach((key) => {
    Object.assign(mappingObject, {
      [key]: key,
    });
  });
  return {
    ...mappingObject,
    // add new version number
    version: {
      key: 'version',
      transform: function () {
        return 'v1.0.170';
      },
    },
    permissionSections: {
      key: 'permissionSections',
      transform: function (permissionSection: PermissionConfig): PermissionConfig {
        const { roles, subscriptions } = permissionSection;
        roles.forEach((item) => {
          const profileZone = item.zones[APP_ZONES.PROFILE];
          if (profileZone) {
            const mobilePages = profileZone?.canvases?.subscription?.['default']?.mobile?.pages as
              | UpdatedPageConfig[]
              | undefined;
            const desktopPages = profileZone?.canvases?.subscription?.['default']?.desktop?.pages as
              | UpdatedPageConfig[]
              | undefined;
            const tabletPages = profileZone?.canvases?.subscription?.['default']?.tablet?.pages as
              | UpdatedPageConfig[]
              | undefined;
            if (mobilePages?.length) {
              addNewPage(mobilePages);
            }
            if (desktopPages?.length) {
              addNewPage(desktopPages);
            }
            if (tabletPages?.length) {
              addNewPage(tabletPages);
            }
          }
        });
        return <PermissionConfig>{
          zones: permissionSection.zones,
          subscriptions,
          roles,
          projectForms: permissionSection.projectForms,
        };
      },
    },
  };
};

function addNewPage(pagesArray: UpdatedPageConfig[]): UpdatedPageConfig[] {
  const beneficiaryRemovedPageIndex = pagesArray.findIndex(
    (page) => page?.name === 'notification-beneficiary-removed',
  );
  const notificationKycSuccessPage = pagesArray.some(
    (page) => page?.name === notificationKycApplicationSuccessPage().name,
  );
  if (beneficiaryRemovedPageIndex !== -1 && !notificationKycSuccessPage)
    pagesArray.splice(beneficiaryRemovedPageIndex + 1, 0, notificationKycApplicationSuccessPage());
  return pagesArray;
}
